import { ReactElement } from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { ITriageRequest, ITriageRequestUpdate } from '~/services/api/triage/types';
import Button from '~/ui/components/common/Button';
import RadioGroup from '~/ui/components/inputs/RadioGroup';
import triageTypeOptions from '~/ui/constants/triageTypeOptions';
import validate from './validate';
import getInitialValues from './getInitialValues';

interface IProps {
  request: ITriageRequest;
  isUpdating: boolean;
  onSubmit: (values: ITriageRequestUpdate) => void;
}

const Form = ({ request, isUpdating, onSubmit }: IProps): ReactElement => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: validate,
    defaultValues: getInitialValues(request),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid item>
        <Grid container justifyContent="center">
          <Grid item>
            <RadioGroup
              name="triageTypeId"
              control={control}
              errors={errors}
              options={triageTypeOptions}
              required
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              isLoading={isUpdating}
              disabled={isUpdating}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default Form;
